import React from "react";
import styled from "styled-components";
import Link from "next/link";
import { Row, Col } from "react-bootstrap";

const StyledPrivacySection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;

  .privacy-body {
    width: 980px;

    padding-top: 1rem;
    padding-bottom: 1rem;

    p {
      margin-bottom: 20px;
      font-family: 'InterRegular';
      font-size: 13px;
      line-height: calc(1.42857rem * (13 / 16));
      text-align: left;
      color: #424242;
    }

    ul {
      margin-bottom: 0;
      padding-left: 28px;
      
      li {
        font-family: 'InterRegular';
        font-size: 13px;
        line-height: 24px;
        text-align: left;
        color: #424242;
      }

      &.secondary-list {
        list-style-type: none;
        padding-left: 0;

        li {
          cursor: pointer;
          
          &:hover {
            color: #0a578b;
          }
        }
      }
    }

    .primary-title,
    .secondary-title {
      font-family: 'InterSemiBold';
      color: #0a578b;
    }

    .primary-title {
      text-transform: uppercase;
    }

    .main-content {
      padding: 15px;
    }
  }

  @media ${({ theme }) => theme.devices.laptopS} {
    .privacy-body {
      width: 720px;
    }
  }

  @media ${({ theme }) => theme.devices.tablet} {
    .privacy-body {
      width: 100%;

      padding-top: 28px;
      padding-bottom: 8px;
      padding-left: 9px;
      padding-right: 9px;

      .main-content {
        padding-top: 0;
        padding-left: 6px;
        padding-right: 6px;
      }
    }
  }
`;

function PrivacySection() {
  const handleScroll = (e) => {
    const { id } = e.target;
    const anchor = document.getElementById(`privacy-content-title-${id.replace("privacy-content-trigger-", "")}`);
    anchor?.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  return (
    <StyledPrivacySection>
      <div className="privacy-body">
        <div className="main-content">
          <p className="primary-title">
            TABLE OF CONTENTS
          </p>
          <p>
            <Row>
              <Col xs={12} md={6}>
                <ul className="secondary-list" onClick={handleScroll}>
                  <li id="privacy-content-trigger-1">Collection of Information</li>
                  <li id="privacy-content-trigger-2">Use of Information</li>
                  <li id="privacy-content-trigger-3">Protection of Information</li>
                  <li id="privacy-content-trigger-4">Cookies</li>
                </ul>
              </Col>
              <Col xs={12} md={6}>
                <ul className="secondary-list" onClick={handleScroll}>
                  <li id="privacy-content-trigger-5">Unsubscribe</li>
                  <li id="privacy-content-trigger-6">Web Links to Third-Party Websites</li>
                  <li id="privacy-content-trigger-7">Modifications to the Privacy Policy</li>
                  <li id="privacy-content-trigger-8">Questions or Concerns</li>
                </ul>
              </Col>
            </Row>
          </p>
          <p id="privacy-content-title-1" className="secondary-title">
            Collection of Information
          </p>
          <p>
            Provider collects necessary personal information to complete the
            services you are seeking. In general, the information collected
            will include your name, mailing address, email address, phone
            number, and payment information, along with other information,
            which depends solely on the service requested. However, you may
            visit this Website without providing any information. Moreover,
            Provider does not knowingly request or collect any information
            from persons under 13 years of age, which is in compliance with
            the requirements of the Childrens Online Privacy Protection Act.
          </p>
          <p id="privacy-content-title-2" className="secondary-title">
            Use of Information
          </p>
          <p>
            The information collected will be used to improve this Website&apos;s
            offerings based on the information and feedback we receive from
            you. Furthermore, your information, whether public or private,
            will not be sold, exchanged, transferred, or given to any third
            party for any reason whatsoever, without your consent, other than
            for the express purpose of delivering the service requested.
            Provider will email you pertinent information and updates
            regarding your order, or other services that may be of some
            interest to you.
          </p>
          <p id="privacy-content-title-3" className="secondary-title">
            Protection of Information
          </p>
          <p>
            Provider has implemented a variety of security measures to
            maintain the safety of your personal information when you place an
            order or enter, submit, or access your personal information.
            Furthermore, Provider offers the use of a secure server. All
            payment information is transmitted via Secure Socket Layer (SSL)
            technology and then encrypted into Provider&apos;s payment gateway,
            Provider&apos;s database, only to be accessible by those authorized
            with strict and limited access rights to such systems. Provider&apos;s
            procedural safeguards are in compliance with applicable laws and
            regulations to protect your personal information from unauthorized
            or inappropriate access. After a transaction is complete, your
            private financial information will not be stored on our servers.
          </p>
          <p id="privacy-content-title-4" className="secondary-title">
            Cookies
          </p>
          <p>
            Provider does not use cookies.
          </p>
          <p id="privacy-content-title-5" className="secondary-title">
            Unsubscribe
          </p>
          <p>
            You may unsubscribe from future communications.
            Please send your request via our <Link href="/contactus">contact form</Link>.
          </p>
          <p id="privacy-content-title-6" className="secondary-title">
            Web Links to Third-Party Websites
          </p>
          <p>
            Provider may have web links to third-party websites, which may
            request your personal information or use cookies. Provider is not
            responsible for the security or privacy practices utilized by
            third parties, though we strive to provide access to third parties
            that share similar practices.
          </p>
          <p id="privacy-content-title-7" className="secondary-title">
            Modifications to the Privacy Policy
          </p>
          <p>
            Provider reserves the right to modify the Privacy Policy without
            notice. Please review the Privacy Policy periodically to be
            informed of any changes.
          </p>
          <p id="privacy-content-title-8" className="secondary-title">
            Questions or Concerns
          </p>
          <p>
            If you have questions or concerns about the Privacy Policy, please
            contact Customer Support at or by email via our&nbsp;
            <Link href="/contactus">contact form</Link>.
          </p>
        </div>
      </div>
    </StyledPrivacySection>
  );
}

export default PrivacySection;
